import React, { useEffect, useState, useRef } from 'react'

import {
  Button, OverlayTrigger, Popover, Image
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';
import Truncate from 'react-truncate';
import { IKImage } from "imagekitio-react";

import styles from './componentStyles.module.scss';

const ContentConfigCard = ({ icon, name, mapping, gatingSetting, setGatingSetting, gatingConfigs, handleReset }) => {

  const iconUrl = _.get(icon, 'url', '') || _.get(icon, 'key', '');
  const isLocked = gatingConfigs.some(item => item.enabled) || false;
  const entityType = _.get(mapping,'content.entityType');

  const popover = (
    <Popover key={mapping.id} bsPrefix="popover" className={styles.assetGatingContainer}>
      <Popover.Body className={styles.assetGatingContainerBody}>
        {/* <div className={styles.assetGatingContainerContent}>
          <span onClick={handleReset}><i className={cx("cleverstory-view")} />View Asset</span>
        </div>
        <div className={styles.assetGatingContainerContent}>
          <span onClick={handleReset}><i className={cx("cleverstory-resource-center")} />Open in Content Library</span>
        </div> */}
        <div className={styles.assetGatingContainerContent}>
          <span onClick={handleReset}><i className={cx("cleverstory-rotate-left")} />Reset to Original</span>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className={cx(styles.actionCardContainer, { [styles.actionCardSlide]: gatingSetting })}>
      {icon && (
        <IKImage
          className={styles.icon}
          path={iconUrl}
        />)
      }
      {
        (!icon && name) &&  (<img src={'/images/storyboard.png'} className={styles.icon} />)
      }
      {
        (!icon && !name) && (<div className={styles.multipleDoc}><Image src={`${process.env.REACT_APP_UI_URL}/images/multidoc.svg`} className={styles.icon} /></div>)
      }
      <div className={styles.detailsWrapper}>
        <div className={styles.name}>
          <span className={styles.type}>Original Asset</span>
          <span className={styles.asset}>
            <Truncate lines={1}>
              { !name ? '-Multiple Asset-': name}
            </Truncate>
          </span>
        </div>
        <div className={styles.actions}>
          {entityType != "page" &&
            <Button onClick={() => setGatingSetting(!gatingSetting)} className={cx(styles.lockAction, { [styles.unlock]: !isLocked })} variant='info'>
              {isLocked ? <i className={cx('cleverstory-lock')} /> : <i className={cx('cleverstory-unlock')} />}
            </Button>
          }
          <OverlayTrigger
            rootClose={true}
            rootCloseEvent="mousedown"
            key={mapping.id}
            trigger="click"
            placement="bottom"
            overlay={popover}
          >
            <i className={cx('cleverstory-more', styles.iconMore)} />
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export default ContentConfigCard